module.exports = __webpack_public_path__ + "img/members.f4745f08.jpg";